export const SelectList = ({label, options, requested, value, setValue, size, selectAll}) => {


    const handelChanges = (inputValue) => {
        if (value.includes(inputValue)) {
            setValue(value.filter((item) => item !== inputValue));
        } else {
            setValue([...value, inputValue]);
        }
    }


    return (
        <fieldset className={"h-full flex flex-col justify-center mb-8 max-h-[400px] max-w-[500px] w-full"}>

            {(label !== "") && (
                <h4 className={`font-semibold ${size === 'small' ? 'text-sm' : 'text-xl'} mb-8  text-gray-900`}>
                    {label}<span className='ml-1 text-sm font-light text-indigo-900 text-xs'>{requested ? '(Pflichtfeld)' : ''}</span>
                </h4>
            )}
            <div className="space-y-4 flex flex-col flex-1">
                {selectAll && (
                    <div className="flex items-start px-2 h-full">
                        <div className="flex h-6  items-center">
                            <input
                                id="selectAll"
                                name="selectAll"
                                type="checkbox"
                                checked={value.length === options.length ? true : false}
                                value="selectAll"
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setValue(options.map((option) => option.id));
                                    } else {
                                        setValue([]);
                                    }
                                }}
                                aria-describedby="comments-description"
                                className={`${value.length === options.length ? 'text-indigo-900' : 'text-indigo-600'} h-6 w-6 rounded-full border-2 border-gray-500 focus:ring-0 focus:ring-offset-0 cursor-pointer`}
                            />
                        </div>
                        <div className="ml-3 mb-2 ">
                            <label 
                                htmlFor="selectAll"
                                className="text-gray-550 text-xs cursor-pointer"
                            >
                                Alle abwählen
                            </label>
                        </div>
                    </div>
                )}
                {options.map((option) => {
                    const isSelected = value.find(element => element === option.id);
                    return (
                    <div className={`${isSelected ? 'bg-gray-200' : ''} flex items-start border-gray-300 p-2 rounded-lg h-full`} key={option.id}>
                        <div className="flex h-6 items-center">
                            <input
                                id={option.id}
                                name={option.name}
                                type="checkbox"
                                checked={isSelected ? true : false}
                                value={option.id}
                                onChange={(e) => {
                                    handelChanges(e.target.value)
                                }}
                                aria-describedby="comments-description"
                                className={`${isSelected ? 'text-gray-900' : 'text-indigo-600'} h-6 w-6 rounded border-2 border-gray-500 focus:ring-0 focus:ring-offset-0 cursor-pointer`}
                            />
                        </div>
                        <div className="ml-3 text-md">
                            <label 
                                htmlFor={option.id}
                                className={`${isSelected ? "text-gray-900 " : "text-gray-550"} text-sm cursor-pointer`}
                            >
                                {option.name}
                            </label>
                        </div>
                    </div>
                )})}
            </div>
        </fieldset>
    )
}
